import { render, staticRenderFns } from "./responsive-icon.vue?vue&type=template&id=25b9b61c&scoped=true&"
import script from "./responsive-icon.vue?vue&type=script&lang=js&"
export * from "./responsive-icon.vue?vue&type=script&lang=js&"
import style0 from "./responsive-icon.vue?vue&type=style&index=0&id=25b9b61c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b9b61c",
  null
  
)

export default component.exports